export default "__VITE_ASSET__1d4e7d45__"